import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserProfileStore } from '../store/user-profile.store';

export const authGuard: CanActivateFn = () => {
  const userProfileStore = inject(UserProfileStore);
  const router = inject(Router);

  if (userProfileStore.isAuthenticated()) {
    return true;
  } else {
    // Redirect to login or landing page if not authenticated
    return router.parseUrl('/login'); // Change '/login' to your actual login/landing route
  }
};